<script setup>
import { formattedPrices } from '@/core/utils/formatters'
import { onMounted, onUnmounted, ref } from 'vue'
import Balon_1 from '@/assets/images/tienda/balon1.webp'
import Balon_2 from '@/assets/images/tienda/balon2.webp'
import Balon_3 from '@/assets/images/tienda/balon3.webp'
import { useRouter } from 'vue-router';

const router = useRouter()
const cartmenu = ref(false)
const productsList = ref([
  {
    id: 1,
    image: Balon_1,
    url: '/',
    name: 'Balón Molten Naranja/Blanco',
    size: 'M',
    gender: '',
    price: 320.0,
    qty: 2,
  },
  {
    id: 2,
    image: Balon_2,
    url: '/',
    name: 'Balón Molten Azul/Blanco',
    size: '',
    gender: '',
    price: 50.0,
    qty: 5,
  },
  {
    id: 3,
    image: Balon_3,
    url: '/',
    name: 'Balón Mikasa Amarillo',
    size: '',
    gender: 'H',
    price: 800.0,
    qty: 1,
  },
])

onMounted(() => {
  window.addEventListener('click', close)
})

onUnmounted(() => {
  window.removeEventListener('click', close)
})

const close = (e) => {
  if (!e.target.closest('#buttonCart')) {
    cartmenu.value = false
  }
}

const resolveTotalItem = (data) => {
  return formattedPrices(Number(data.price) * Number(data.qty))
}

const resolveTotal = () => {
  return formattedPrices(productsList.value.reduce((sum, { price, qty }) => sum + price * qty, 0))
}

const toUrl = val => {
  const url = `/${val}`
  router.replace(url)
  cartmenu.value = false
}
  
</script>
<template>
  <li id="buttonCart" class="dropdown inline-block relative ps-0.5">
    <button
      @click.prevent="cartmenu = !cartmenu"
      class="size-9 inline-flex items-center justify-center tracking-wide align-middle duration-500 text-base text-center rounded-full bg-red-cc border border-red-cc text-white"
      type="button"
    >
      <i data-feather="shopping-cart" class="h-4 w-4"></i>
    </button>
    <!-- Dropdown menu -->
    <div
      class="dropdown-menu absolute end-0 m-0 mt-4 z-10 w-80 rounded-md bg-white dark:bg-slate-900 shadow dark:shadow-gray-800"
      :class="cartmenu === false ? 'hidden' : ''"
    >
      <ul class="py-3 text-start" aria-labelledby="dropdownDefault">
        <li v-for="(item, index) in productsList" :key="index">
          <a
            :href="item.url"
            class="flex items-center justify-between py-1.5 px-4"
          >
            <span class="flex items-start">
              <img
                :src="item.image"
                class="rounded shadow dark:shadow-gray-800 w-9"
                alt=""
              />
              <span class="ms-3">
                <span class="block font-semibold leading-5">
                  {{ item.name }}
                  {{ item.size !== '' ? `(${item.size})` : item.gender !== '' ? `(${item.gender})` : '' }}
                </span>
                <span class="block text-sm text-slate-400">
                  {{ `${formattedPrices(item.price)} x ${item.qty}` }}
                </span>
              </span>
            </span>

            <span class="font-semibold">
              {{ resolveTotalItem(item) }}
            </span>
          </a>
        </li>

        <li class="border-t border-gray-100 dark:border-gray-800 my-2"></li>

        <li class="flex items-center justify-between py-1.5 px-4">
          <h6 class="font-semibold mb-0">Total(S/):</h6>
          <h6 class="font-semibold mb-0">{{ resolveTotal() }}</h6>
        </li>

        <li class="py-1.5 px-4">
          <span class="text-center flex justify-between">
            <button
              @click="toUrl('carrito')"
              class="py-[5px] px-4 inline-block font-semibold cursor-pointer tracking-wide align-middle duration-500 text-sm text-center rounded-md bg-blue-cc border border-blue-cc text-white"
              >Ver Carrito</button
            >
            <button
             @click="toUrl('checkout')"
              class="py-[5px] px-4 inline-block font-semibold cursor-pointer tracking-wide align-middle duration-500 text-sm text-center rounded-md bg-blue-cc border border-blue-cc text-white"
              >Checkout</button
            >
          </span>
        </li>
      </ul>
    </div>
  </li>
</template>
<style lang=""></style>
